import { useCallback } from 'react';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const useGoogleAnalytics = () => {
  const trackEvent = useCallback(
    (action: string, category: string, label?: string, value?: number) => {
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', action, {
          event_category: category,
          event_label: label,
          value: value,
        });
      }
    },
    [],
  );

  const trackFormSubmit = useCallback(
    (formName: string, formType: string = 'form') => {
      trackEvent('form_submit', 'engagement', `${formType}_${formName}`);
    },
    [trackEvent],
  );

  const trackFormStart = useCallback(
    (formName: string, formType: string = 'form') => {
      trackEvent('form_start', 'engagement', `${formType}_${formName}`);
    },
    [trackEvent],
  );

  const trackFormError = useCallback(
    (formName: string, errorType: string, formType: string = 'form') => {
      trackEvent(
        'form_error',
        'engagement',
        `${formType}_${formName}_${errorType}`,
      );
    },
    [trackEvent],
  );

  const trackPageView = useCallback((pageName: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-FBQRXP420R', {
        page_title: pageName,
        page_location: window.location.href,
      });
    }
  }, []);

  const trackCustomEvent = useCallback(
    (eventName: string, parameters?: Record<string, any>) => {
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, parameters);
      }
    },
    [],
  );

  return {
    trackEvent,
    trackFormSubmit,
    trackFormStart,
    trackFormError,
    trackPageView,
    trackCustomEvent,
  };
};
